export default "__VITE_ASSET__33yhs8_p__"